import { useOutletContext } from 'applications/common/routing/outlet-context.js';
import MojitoModules from 'mojito/modules';
import LeaguesFilterSection from 'applications/sports/pages/sport-page/views/leagues-filter-section/index.js';

const PriceBoostCoupon = MojitoModules.PriceBoostCoupon;

export default function PriceBoostsView({ mojitoTools }) {
    const { config } = mojitoTools;
    const { priceBoosts } = useOutletContext() ?? {};
    const groupId = priceBoosts?.group;
    return (
        <LeaguesFilterSection config={config.leaguesFilterSection} groupId={groupId}>
            {selectedLeagueId => (
                <PriceBoostCoupon
                    selectedGroupId={selectedLeagueId}
                    boostedGroupId={groupId}
                    config={config.priceBoostCoupon}
                />
            )}
        </LeaguesFilterSection>
    );
}
